<template>
	<div class="page" :style="{height:fixedHeight+'px'}">
		<div class="pageLeft">
			<!-- 日历组件 -->
			<div id="huotiCalendar">
				<el-calendar v-model="calendarValue" v-if="shopValue != '5e9412e0b2bfbc089daerr14'">
					<template slot="dateCell" slot-scope="{date, data}">
						<div class="dateView">
							<div :class="data.isSelected ? 'is-selected' : ''" @click="handelSecectClick(date)"
								class="dateSpan">
								{{ data.day.split('-').slice(2).join('-') }}
							</div>
							<div v-for="(item,index) in errArr" :key="index">
								<div class="circle1" v-if="data.day == item.date && item.checkTimesStatus == 0"></div>
								<div class="circle2" v-if="data.day == item.date && item.exceptionStatus == 1"></div>
							</div>
						</div>
					</template>
				</el-calendar>
				<div class="huotiSelect">
					<el-select v-model="shopValue" placeholder="请选择" @change="handleChange">
						<el-option v-for="item in shops" :key="item.value" :label="item.label" :value="item.value" />
					</el-select>
				</div>
			</div>

			<!-- 宠物转移列表 -->
			<div class="petView">
				<div class="tabView">
					<div :class="tabs == 0?'active':''" @click="handleTabClick(0)" class="tabItem">转移宠物</div>
					<div :class="tabs == 1?'active':''" @click="handleTabClick(1)" class="tabItem">接收宠物</div>
					<el-button type="primary" class="addClick" size="small" @click="dialogAddPet_state = true"
						v-if="shopValue == '5e9412e0b2bfbc089daerr14'">添加宠物</el-button>
				</div>
				<!-- 筛选 -->
				<div class="screenView" v-if="tabs == 0">
					<el-cascader :options="breedValue" @change="handelBreedChange" size="small"
						:props="{ label:'label', value:'id'}" style="width: 140px;" placeholder="品种筛选" clearable>
					</el-cascader>
					<el-select v-model="transCate" placeholder="分类筛选" class="titleSelect" @change="getPetList"
						style="width: 100px" size="small" clearable>
						<el-option v-for="item in cateList" :key="item.value" :label="item.label" :value="item.value" />
					</el-select>
				</div>

				<div class="numView" v-if="tabs == 0">
					<div>已选: {{selectNum}}/{{petCount}}</div>
					<div @click="handleAllPetClick" v-if="allType == 0">全选</div>
					<div @click="handleCancelAllPetClick" v-if="allType == 1">取消全选</div>
				</div>
				<div class="numView" v-if="tabs == 1">
					<div>待接收数量: {{receiveCount}}</div>
				</div>
				<div class="pets" v-if="tabs == 0">
					<div v-for="(item,index) in petList" :key="index" class="petItem"
						@click="handlePetClick(index,item)">
						<div class="petItemL">
							<img :src="item.cover" alt="">
							<div class="petName">{{item.inside_name}}</div>
							<div v-if="item.breed_info != null">{{item.breed_info.name}}</div>
							<div class="petName">{{item.pet_sex}}</div>
						</div>
						<div :class="item.isClick?'isClick':'petItemR'" v-if="item.transferring == 0"></div>
					</div>
				</div>
				<div class="pets" v-if="tabs == 1">
					<div v-for="(item,index) in receiveList" :key="index" class="petItem">
						<div class="petItemL">
							<img :src="item.cover" alt="">
							<div class="petName">{{item.petName}}</div>
							<div>{{item.breed_info.name}}</div>
							<div class="petName">{{item.pet_sex}}</div>
						</div>
						<div class="receiveBtn" @click="handleAddCageClick(item)">接收</div>
					</div>
				</div>
				<div class="petBtn" v-if="tabs == 0">
					<el-select v-model="selectShop" placeholder="请选择" style="width: 150px;">
						<el-option v-for="item in shops" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<el-button type="primary" class="addClick" @click="handleTransClick">转移</el-button>
				</div>
			</div>
		</div>

		<!-- 指挥中心列表 -->
		<div class="lists" v-if="shopValue == '5e9412e0b2bfbc089daerr14'">
			<el-row class="titleView" style="margin-top: 0;">
				<el-col :span="4" style="display: flex;align-items: center;">
					<el-input v-model="keyword" prefix-icon="el-icon-search" placeholder="请输入内容" class="titleInput"
						clearable />
					<el-button type="primary" style="margin-left: 10px;" @click="getPetStockData">搜索</el-button>
				</el-col>
				<el-col :span="6">
					<el-button type="primary" class="addClick" @click="dialogLog_state = true">操作日志</el-button>
					<el-button type="primary" class="addClick" @click="handelTransClick">转移记录</el-button>
					<el-button type="primary" class="addClick" @click="exportpetall">导出</el-button>
				</el-col>
				<el-col :span="13" style="font-weight: bold;">全部类型（猫:{{zhzxCat}}只,犬:{{zhzxDog}}只）</el-col>
			</el-row>
			<div class="listFlex">
				<el-scrollbar style="margin-right: 20px;">
					<el-tree :data="breedValue" @node-click="handleNodeClick" default-expand-all style="width: 140px;">
					</el-tree>
				</el-scrollbar>


				<div class="petTable">
					<el-table :data="petTables">
						<el-table-column label="品种" align="center" width="200">
							<template slot-scope="scope">
								{{scope.row.color}} {{scope.row.category_info.name}}
							</template>
						</el-table-column>
						<el-table-column label="类型" align="center" width="100">
							<template slot-scope="scope">
								<span v-if="scope.row.apply_type.value == '1'">猫类</span>
								<span v-if="scope.row.apply_type.value == '2'">犬类</span>
							</template>
						</el-table-column>
						<el-table-column label="总库存" align="center" width="200">
							<template slot-scope="scope">
								<span
									style="color: #FFAE11;font-weight: bold;">{{scope.row.male_count + scope.row.female_count}}</span>
								(公:{{scope.row.male_count}} 母:{{scope.row.female_count}})
							</template>
						</el-table-column>
						<el-table-column label="门店库存">
							<template slot-scope="scope">
								<span v-for="(item,index) in scope.row.stock_list" :key="index"
									style="margin-right: 10px;"><span
										style="font-weight: bold;">{{item.shopName}}</span>:<span
										style="color: red;font-weight: bold;">{{item.count}}</span></span>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="100" align="center">
							<template slot-scope="scope">
								<el-button type="text" size="small" @click="handelSeeClick(scope.row)">查看</el-button>
							</template>
						</el-table-column>
					</el-table>
					<page :page="tablePage.page" :total="tablePage.total" @change="changeTablePage"
						:pageSize="tablePage.pageSize" style="padding-top: 20px;"></page>
				</div>
				<!-- 转移记录 -->
				<el-drawer title='转移记录' :modal='false' size='60%' :visible.sync="transferDrawer"
					custom-class='drawersend' direction="rtl">
					<el-row style="padding: 0 20px;">
						<el-col :span="5" style="display: flex;align-items: center;">
							<el-input v-model="transKeyword" prefix-icon="el-icon-search" placeholder="请输入内容"
								class="titleInput" clearable />
							<el-button type="primary" style="margin-left: 10px;" @click="getTrans">搜索</el-button>
						</el-col>
						<el-col :span="4" class="flex">
							<div class="m-r-10" style="margin-left: 10px;">状态</div>
							<el-select v-model="transferStatus" placeholder="请选择" class="titleSelect" @change="getTrans"
								style="width: 110px;">
								<el-option v-for="item in transferStatusSel" :key="item.value" :label="item.label"
									:value="item.value" />
							</el-select>
						</el-col>
						<el-col :span="4" class="flex">
							<div class="m-r-10">接收门店</div>
							<el-select v-model="receiveShopId" placeholder="请选择" class="titleSelect" @change="getTrans"
								style="width: 110px;">
								<el-option v-for="item in shops" :key="item.value" :label="item.label"
									:value="item.value" />
							</el-select>
						</el-col>
						<el-col :span="7" class="flex">
							<div class="m-r-10" style="margin-left: 10px;">转移日期</div>
							<el-date-picker v-model="transDate" type="daterange" range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" style="width: 240px;"
								@change="getTrans">
							</el-date-picker>
						</el-col>
						<el-col :span="3" style="text-align: right;">
							<el-button type="primary" class="addClick" @click="handleTransResetClick">重置</el-button>
						</el-col>
					</el-row>
					<div class="cateView" style="padding: 20px;overflow-y: scroll;">

						<el-table :data="transTable">
							<el-table-column prop="insideName" label="名称">
							</el-table-column>
							<el-table-column label="分类" width="60">
								<template slot-scope="scope">
									<span v-if="scope.row.petApplyType == 1">猫类</span>
									<span v-if="scope.row.petApplyType == 2">犬类</span>
								</template>
							</el-table-column>
							<el-table-column prop="breedInfo" label="品种">
								<template slot-scope="scope">
									<span>{{scope.row.breedInfo == null?'--':scope.row.breedInfo}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="epromNo" label="芯片编号" width="160">
							</el-table-column>
							<el-table-column prop="insideNo" label="脖圈号" width="160">
							</el-table-column>
							<el-table-column label="状态" width="80">
								<template slot-scope="scope">
									<span v-if="scope.row.transferStatus == 0">转移中</span>
									<span v-if="scope.row.transferStatus == 1">转移成功</span>
								</template>
							</el-table-column>
							<el-table-column prop="transferUser" label="转移人" width="90">
							</el-table-column>
							<el-table-column prop="transferTime" label="转移时间" width="150">
								<template slot-scope="scope">
									<span>{{$public.FTime(scope.row.transferTime,'YYYY-MM-DD HH:mm:ss')}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="receiverShopName" label="接收门店">
							</el-table-column>
							<el-table-column prop="receiveUser" label="接收人">
							</el-table-column>
						</el-table>
						<page :page="transPage.page" :total="transPage.total" @change="transTablePage"
							:pageSize="transPage.pageSize" style="padding-top: 20px;"></page>
					</div>
				</el-drawer>
				<!-- 查看 -->
				<el-drawer title='宠物位置' :modal='false' size='60%' :visible.sync="drawer" custom-class='drawersend'
					direction="rtl">

					<div class="cateView" style="padding: 20px;overflow-y: scroll;">
						<el-table :data="cateTable">
							<el-table-column prop="feed_shop_name" label="门店">
							</el-table-column>
							<el-table-column prop="breed_info.name" label="品种" width="120">
							</el-table-column>
							<el-table-column label="分类" width="60">
								<template slot-scope="scope">
									<span v-if="scope.row.apply_type.value == '1'">猫类</span>
									<span v-if="scope.row.apply_type.value == '2'">犬类</span>
								</template>
							</el-table-column>
							<el-table-column prop="inside_name" label="名称">
							</el-table-column>
							<el-table-column label="星级" width="60">
								<template slot-scope="scope">
									{{scope.row.pet_level.stars}}星
								</template>
							</el-table-column>
							<el-table-column prop="sale_price" label="销售价" width="100">
							</el-table-column>
							<el-table-column prop="eprom_no" label="芯片编号" width="160">
							</el-table-column>
							<el-table-column prop="inside_no" label="脖圈号" width="160">
							</el-table-column>
							<el-table-column prop="pet_sex" label="性别" width="60">
							</el-table-column>
							<el-table-column label="状态" width="60" prop="pet_status.title">
							</el-table-column>
							<el-table-column prop="address" label="操作" width="60">
								<template slot-scope="scope">
									<el-button type="text" size="small" @click="handleNavClick(scope.row)">详情
									</el-button>
								</template>

							</el-table-column>
						</el-table>
						<page :page="petPage.page" :total="petPage.total" @change="petTablePage"
							:pageSize="petPage.pageSize" style="padding-top: 20px;"></page>
					</div>
				</el-drawer>
			</div>
		</div>

		<!-- 非指挥中心列表 -->
		<div class="lists" v-else>
			<div class="headView">
				<div>{{this.getStartEndData(this.calendarValue).formatDate}}</div>
				<div>全部（猫:{{allCatNum}},犬:{{allDogNum}}）</div>
				<div>注：笼子内左上角红色标识为笼子内宠物异常，右上角黄色标识为笼子内宠物检查次数不足</div>
			</div>
			<div class="storeView">
				<!-- 房间 -->
				<div class="roomView">
					<div :class="item.room_id == roomId?'roomActive':'room'" v-for="(item, index) in roomList"
						:key="index" @click="handleRoomClick(item)">{{item.room_name}}</div>
				</div>
				<div class="cageView">
					<div class="cage" v-for="(item,index) in cageList" :key="index">
						<template v-if="item.room_id != ''">
							<div class="cageTitle">{{item.room_name}} (猫: {{item.cat?item.cat:"0"}}只, 犬:
								{{item.dog?item.dog:'0'}}只)
							</div>
							<div :class="cageId == cageItem.cage_id?'cageItemActive':'cageItem'"
								v-for="(cageItem,cageIndex) in item.cage_info" :key="cageIndex"
								@click="handleCageClick(cageItem)">
								<img src="../../../assets/img/icon_yi.png" alt="" class="iconYi"
									v-if="cageItem.exception == true">
								<img src="../../../assets/img/icon_que.png" alt="" class="iconQue"
									v-if="cageItem.check == true">
								<div>{{cageItem.cage_name}}</div>
								<div class="petNum" v-if="cageItem.pet_list.length == 0">空</div>
								<template v-else>
									<div class="petNum">
										<span v-if="cageItem.dogCount">犬:{{cageItem.dogCount}}只</span>
										<span v-if="cageItem.catCount">猫:{{cageItem.catCount}}只</span>
									</div>

								</template>
							</div>
						</template>
					</div>
				</div>
			</div>
			<!-- 搜索框 -->
			<el-row class="titleView">
				<el-col :span="4" style="display: flex;align-items: center;">
					<el-input v-model="serchValue" prefix-icon="el-icon-search" placeholder="请输入内容" class="titleInput"
						clearable />
					<el-button type="primary" style="margin-left: 10px;" @click="handelSearchClick">搜索</el-button>
				</el-col>
				<el-col :span="2.5" class="flex">
					<div class="m-r-10">分类</div>
					<el-select v-model="className" placeholder="请选择" class="titleSelect" @change="getTableData"
						style="width: 80px;">
						<el-option v-for="item in classNames" :key="item.value" :label="item.label"
							:value="item.value" />
					</el-select>
				</el-col>
				<el-col :span="2.5" class="flex">
					<div class="m-r-10">检查</div>
					<el-select v-model="censor" placeholder="请选择" class="titleSelect" @change="getTableData"
						style="width: 100px;">
						<el-option v-for="item in censors" :key="item.value" :label="item.label" :value="item.value" />
					</el-select>
				</el-col>
				<el-col :span="2.5" class="flex">
					<div class="m-r-10">异常</div>
					<el-select v-model="deviant" placeholder="请选择" class="titleSelect" @change="getTableData"
						style="width: 80px;">
						<el-option v-for="item in deviants" :key="item.value" :label="item.label" :value="item.value" />
					</el-select>
				</el-col>
				<el-col :span="2.5" class="flex">
					<div class="m-r-10">状态</div>
					<el-select v-model="statu" placeholder="请选择" class="titleSelect" @change="getTableData"
						style="width: 100px;">
						<el-option v-for="item in status" :key="item.value" :label="item.label" :value="item.value" />
					</el-select>
				</el-col>
				<el-col :span="5.5" class="flex">
					<div class="m-r-10">价格区间</div>
					<el-input v-model="minPrice" placeholder="请输入价格" class="titleInput" clearable
						style="width: 120px;" />
					<div>- -</div>
					<el-input v-model="maxPrice" placeholder="请输入价格" class="titleInput" clearable
						style="width: 120px;" />
				</el-col>
				<el-col :span="5" style="text-align: right;">
					<el-button type="primary" class="addClick" @click="handleResetClick">重置</el-button>
					<el-button type="primary" class="addClick" @click="dialogLog_state = true">操作日志</el-button>
				</el-col>
			</el-row>
			<!-- table表格 -->
			<el-table :data="tableData" style="width: 100%" id="pettable" size="small" class="customer-table">
				<el-table-column prop="postion" label="位置" align="center" :key="1" width="200px"
					v-if="shopValue != '5e9412e0b2bfbc089daerr14'">
				</el-table-column>
				<el-table-column prop="inside_name" label="名称" align="center" :key="2">
				</el-table-column>
				<el-table-column prop="class_name" label="分类" align="center" :key="3">
					<template slot-scope="scope">
						<div>{{scope.row.applyType.value == 1?'猫类':'犬类'}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="categoryInfo" label="品种" align="center" :key="4">
				</el-table-column>
				<el-table-column prop="checkTimes" label="检查" align="center" :key="5">
					<template slot-scope="scope">
						<div v-if="scope.row.checkTimes == 3">已完成</div>
						<div v-if="scope.row.checkTimes < 3">未完成</div>
					</template>
				</el-table-column>
				<el-table-column prop="exceptionTimes" label="异常" align="center" :key="6">
					<template slot-scope="scope">
						<div v-if="scope.row.exceptionTimes > 0">异常:{{scope.row.exceptionTimes}}</div>
						<div v-if="scope.row.exceptionTimes == 0">--</div>
					</template>
				</el-table-column>
				<el-table-column prop="eprom_no" label="芯片编号" align="center" :key="7">
					<template slot-scope="scope">
						<div v-if="scope.row.eprom_no == ''">--</div>
						<div v-else>{{scope.row.eprom_no}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="inside_no" label="脖圈号" align="center" :key="8">
					<template slot-scope="scope">
						<div v-if="scope.row.inside_no == ''">--</div>
						<div v-else>{{scope.row.inside_no}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="status.title" label="状态" align="center" :key="9">
					<template slot-scope="scope">
						<div v-if="scope.row.status.value == '-1'" style="color: #F30000;">亡故</div>
						<div v-if="scope.row.status.value == '0'" style="color: #F30000;">异常</div>
						<div v-if="scope.row.status.value == '1'">正常</div>
						<div v-if="scope.row.status.value == '2'" style="color: #FFAE11;">预定</div>
						<div v-if="scope.row.status.value == '3'" style="color: #FFAE11;">转移中</div>
					</template>
				</el-table-column>
				<el-table-column prop="salePrice" label="销售价" align="center" :key="10">
				</el-table-column>
				<el-table-column label="操作" width="100" align="center" :key="11">
					<template slot-scope="scope">
						<el-button @click="handleNavClick(scope.row)" type="text" size="small">详情</el-button>
						<el-button @click="handleDeleteClick(scope.row)" type="text" size="small"
						>删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<page :page="page.page" :total="page.total" @change="changePage" :pageSize="page.pageSize"></page>
		</div>


		<!-- 接收弹框 -->
		<div v-if="dialogAddCage_state">
			<dialogAddCage @refresh="handleRefresh" @closeOn="handleAddCageClose" @closeClick="handleRearchClick"
				:buCodeState.sync="dialogAddCage_state" :receiveId.sync="receiveId" :shopId.sync="shopValue"
				:eprom_no.sync="eprom_no"></dialogAddCage>
		</div>
		<!-- 操作日志弹框 -->
		<div v-if="dialogLog_state">
			<dialogLog @closeOn="handleLogClose" :logState.sync="dialogLog_state" :shopId.sync="shopValue"></dialogLog>
		</div>
		<!-- 添加宠物弹框 -->
		<div v-if="dialogAddPet_state">
			<dialogAddPet @closeOn="handleAddPetClose" @closeClick="handelRearchClick"
				:addPetState.sync="dialogAddPet_state"></dialogAddPet>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	import {
		cage,
		petList,
		getTransferList,
		memberReceiveList,
		deletePet,
		transfer,
		petCalendar,
		breedList,
		petStock,
		// transfarlist
	} from "@/api/purchaseApi.js"
	
	import page from "../../../components/page.vue"
	import dialogAddCage from "../../../components/dialog_addCage.vue"
	import dialogLog from "../../../components/dialog_log.vue"
	import dialogAddPet from "../../../components/dialog_addPet.vue"
	export default {
		components: {
			page,
			dialogAddCage,
			dialogLog,
			dialogAddPet
		},
		data() {
			return {
				dialogAddCage_state: false, //接收弹框状态
				dialogLog_state: false, //操作日志弹框
				dialogAddPet_state: false, //新增宠物弹框
				page: {
					page: 1,
					pageSize: 7,
					total: 0
				},
				tablePage: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				serchValue: '', //搜索数据
				className: '0', //分类数据
				classNames: [{
					value: '0',
					label: '全部'
				}, {
					value: '1',
					label: '猫类'
				}, {
					value: '2',
					label: '犬类'
				}],
				censor: -1, //检查数据
				censors: [{
					value: -1,
					label: '全部'
				}, {
					value: 0,
					label: '未完成'
				}, {
					value: 1,
					label: '已完成'
				}],
				deviant: -1, //异常数据
				deviants: [{
					value: -1,
					label: '全部'
				}, {
					value: 1,
					label: '有'
				}, {
					value: 0,
					label: '无'
				}],
				statu: -99, //状态
				status: [{
					value: -99,
					label: '全部'
				}, {
					value: -1,
					label: '亡故'
				}, {
					value: 0,
					label: '异常'
				}, {
					value: 1,
					label: '正常'
				}, {
					value: 2,
					label: '预定'
				}, {
					value: 3,
					label: '转移中'
				}],
				// 日历
				calendarValue: new Date(), //日历数据
				tableData: [], //表格数据
				fixedHeight: '',
				shopValue: this.$store.state.shopId, //门店id
				shops: [{
					value: '5e9412e0b2bfbc089daerr12',
					label: '金水区店'
				}, {
					value: '5e9412e0b2bfbc089daerr14',
					label: '指挥中心'
				}, {
					value: '5e9412e0b2bfbc089daerr17',
					label: '线上店'
				}, {
					value: '5e9412e0b2bfbc089daerr18',
					label: '郑东新区店'
				},{
					value: '5e9412e0b2bfbc089daerr10',
					label: '驯养中心'
				}, {
					value: '5e9412e0b2bfbc089daerr11',
					label: '小程序'
				}],
				selectShop:'',  //转移门店数据

				petList: [], //转移宠物列表
				petCount: 0, //转移宠物数量
				selectNum: 0, //选中宠物
				restaurants: [], //匹配建议数组
				tabs: 0, //tab切换
				petIndex: null, //选中宠物
				allType: 0, //全选或者取消全选
				roomList: [], //房间列表
				roomId: '', //房间id
				allList: [], //所有宠物列表
				cageId: '', //笼子id
				cageList: [], //当前房间笼子列表
				receiveList: [], //接收列表
				receiveCount: 0, //接收数量
				receiveId: '', //转移id
				minPrice: null, //最小价格
				maxPrice: null, //最大价格
				allCatNum: 0, //全部猫数量
				allDogNum: 0, //全部狗数量
				eprom_no: '', //芯片编号
				errArr: [], //日历
				breedValue: [], //分类列表
				zhzxDog: 0, //指挥中心狗数量
				zhzxCat: 0, //指挥中心猫数量
				keyword: '', //指挥中心关键字
				categoryId: '', //指挥中心关键字
				petTables: [], //指挥中心table
				drawer: false, //弹框状态
				transferDrawer: false, //转移弹框
				petPage: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				transPage: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				transKeyword: '', //转移记录关键字
				cateTable: [], //弹框宠物具体列表
				petCategoryId: '', //弹框id
				transferStatus: '', //转移记录状态
				receiveShopId: '', //接收门店id
				transDate: [], //转移日期
				transferStatusSel: [{
					value: 0,
					label: '转移中'
				}, {
					value: 1,
					label: '转移成功'
				}],
				transTable: [], //转移记录列表
				breedid: '', //筛选品种
				cateList: [{
					label: '猫类',
					value: "1"
				}, {
					label: '犬类',
					value: "2"
				}],
				transCate: '', //分类id
			}
		},
		created() {
			this.fixedHeight = document.documentElement.clientHeight - 106;
			this.$nextTick(() => {
				// 点击前一个月
				let prevBtn = document.querySelector(
					".el-calendar__button-group .el-button-group>button:nth-child(1)"
				);
				prevBtn.addEventListener("click", () => {
					this.getTableData()
					this.getMonthData()
					this.getPetsByShopList();
				});

				//点击下一个月
				let nextBtn = document.querySelector(
					".el-calendar__button-group .el-button-group>button:nth-child(3)"
				);
				nextBtn.addEventListener("click", () => {
					console.log(this.calendarValue);
					this.getTableData()
					this.getMonthData()
					this.getPetsByShopList();
				});

				//点击今天
				let todayBtn = document.querySelector(
					".el-calendar__button-group .el-button-group>button:nth-child(2)"
				);
				todayBtn.addEventListener("click", () => {
					this.getTableData()
					this.getMonthData()
					this.getPetsByShopList();
				});
			});
			let that = this;
			document.onkeydown = function() {
				var key = window.event.keyCode;
				if (key == 13) {
					that.getTableData()
				}
			}

			console.log('返回历史')
			// console.log(this.$store.state.userInfo.role)
		},

		mounted() {
			this.restaurants = this.loadAll();
			//待转移宠物列表
			this.getPetList();
			//接收宠物列表
			this.getMemberReceiveList()
			//获取日历
			this.getMonthData();
			//初始化房间笼子
			this.getPetsByShopList();
			//初始化table内所有宠物
			this.getTableData();
			//获取宠物分类
			this.getBreedListData();
			//库存列表
			this.getPetStockData()
		},
		methods: {
			//搜索
			handelSearchClick() {
				this.page.page = 1;
				this.getTableData()
			},
			//切换数据
			handelBreedChange(val) {
				console.log(val)
				this.breedid = val[1];
				this.getPetList()
			},
			//重置
			handleTransResetClick() {
				this.keyword = '';
				this.receiveShopId = '';
				this.transDate = [];
				this.transferStatus = '';
				this.transPage.page = 1;
				this.getTrans()
			},
			//转移记录按钮
			handelTransClick() {
				this.transferDrawer = true;
				this.getTrans()
			},
			//转移记录
			getTrans() {
				// let transferStartTime = '';
				// let transferStopTime = '';
				// if (this.transDate.length == 0) {
				// 	transferStartTime = '';
				// 	transferStopTime = '';
				// } else {
				// 	transferStartTime = new Date(this.transDate[0]).getTime() / 1000;
				// 	transferStopTime = new Date(this.transDate[1]).getTime() / 1000;
				// }
				// let params = {
				// 	pageIndex: this.transPage.page,
				// 	pageSize: this.transPage.pageSize,
				// 	keyword: this.transKeyword,
				// 	transferShopId: this.shopValue,
				// 	receiveShopId: this.receiveShopId,
				// 	transferStartTime: transferStartTime,
				// 	transferStopTime: transferStopTime,
				// 	transferStatus: this.transferStatus
				// }
				// transfarlist(params).then((res) => {
				// 	if (res.code == 0) {
				// 		console.log('转移记录', res)
				// 		this.transTable = res.data.data;
				// 		this.transPage.total = res.data.count;
				// 	}
				// })
			},
			//指挥中心弹框
			getProductList() {
				let params = {
					pageIndex: this.petPage.page,
					pageSize: this.petPage.pageSize,
					petCategoryId: this.petCategoryId,
					petStatus: '0,1,2,3'
				}
				getTransferList(params).then((res) => {
					if (res.code == 0) {
						console.log('弹框列表', res)
						this.cateTable = res.data.data;
						this.petPage.total = res.data.count;
					}
				})
			},
			//查看按钮
			handelSeeClick(row) {
				console.log(row)
				this.drawer = true;
				this.petCategoryId = row.petCategoryId;
				this.getProductList()
			},
			//转移记录弹框记录分页
			transTablePage(num) {
				this.transPage.page = num;
				this.getTrans()
			},
			//弹框分页
			petTablePage(num) {
				this.petPage.page = num;
				this.getProductList()
			},
			//指挥中心分页
			changeTablePage(num) {
				this.tablePage.page = num;
				this.getPetStockData();
			},
			//获取宠物库存列表
			getPetStockData() {
				let params = {
					pageIndex: this.tablePage.page,
					pageSize: this.tablePage.pageSize,
					keyword: this.keyword,
					categoryId: this.categoryId

				}
				petStock(params).then((res) => {

					if (res.code == 0) {
						// let count = 0;
						res = res.data;
						for (let i = 0; i < res.data.length; i++) {
							for (let j = 0; j < res.data[i].stock_list.length; j++) {
								res.data[i].stock_list[j].count = 0;
								for (let k = 0; k < res.data[i].stock_list[j].levelInfos.length; k++) {
									res.data[i].stock_list[j].count = (res.data[i].stock_list[j].count + res.data[
										i].stock_list[j].levelInfos[k].count);
								}
							}
						}
						console.log('库存列表', res.data)
						this.petTables = res.data;
						this.tablePage.total = res.count;
					}
				})
			},
			//点击Tree节点
			handleNodeClick(date) {
				console.log(date)
				this.categoryId = date.id;
				this.getPetStockData()
			},
			//获取宠物分类
			getBreedListData() {
				breedList().then((res) => {
					console.log('宠物分类', res)
					if (res.code == 0) {
						this.zhzxDog = res.data.dog;
						this.zhzxCat = res.data.cat;
						this.breedValue = res.data.category;
					}
				})
			},
			//获取当前日历
			getMonthData() {
				// console.log(this.calendarValue)
				let now = new Date(this.calendarValue);
				// console.log(now)
				let year = now.getFullYear();
				let month = (now.getMonth() + 1) < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth() + 1);
				let temp = new Date(year, month, 0);
				let days = temp.getDate()
				let startDateStr = `${year}-${month}-01 00:00:00`;
				let endDateStr = `${year}-${month}-${days} 23:59:59`;
				// console.log(year,month,days,startDateStr,endDateStr)
				let startDate = new Date(startDateStr.replace(/-/g, '/')).getTime() / 1000;
				let endDate = new Date(endDateStr.replace(/-/g, '/')).getTime() / 1000;
				// console.log(startDate, endDate)
				let id = '';
				// console.log(id)
				let pamars = {
					startTime: startDate,
					endTime: endDate,
					shopId: this.shopValue,
					petId: id
				}
				petCalendar(pamars).then((res) => {
					console.log('日历', res)
					if (res.code == 0) {
						this.errArr = res.data
					}
				})
			},
			//删除宠物
			handleDeleteClick(item) {
				console.log(item)
				this.$confirm('是否删除该宠物?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						id: item.petId
					}
					deletePet(params).then((res) => {
						console.log(res)
						if (res.code == 0) {
							this.getTableData();
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getTableData();
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//关闭弹框
			handleRefresh() {
				this.dialogAddCage_state = false;
				this.getMemberReceiveList();
				this.getPetList();
				this.getTableData()
			},
			//宠物转移按钮
			handleTransClick() {
				console.log('本人信息', this.$store.state.userInfo)
				if (this.selectShop == '') {
					this.$message({
						message: '请选择门店',
						type: 'warning'
					});
					return
				}
				let pets = []
				for (let i = 0; i < this.petList.length; i++) {
					if (this.petList[i].isClick) {
						pets[i] = {
							petId: this.petList[i].petId,
							petName: this.petList[i].inside_name
						}
					}
				}
				pets = pets.filter(item => item);
				if (pets.length == 0) {
					this.$message({
						message: '请选择需要转移宠物',
						type: 'warning'
					});
					return
				}
				this.$confirm('是否确认转移？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let pamars = {
						transferUserId: this.$store.state.userInfo.uid, //转移人id
						transferUserName: this.$store.state.userInfo.uName, //转移人名字
						transferShopId: this.shopValue, //转移门店编号
						transferShopName: this.getShopNameData(this.shopValue), //转移门店名称
						receiveShopId: this.selectShop, //接收门店编号
						receiveShopName: this.getShopNameData(this.selectShop), //接收门店名称
						petTransList: pets,
						remark: ''
					}
					console.log(pamars)
					transfer(pamars).then((res) => {
						console.log(res)
						if (res.code == 0) {
							this.$message({
								message: '转移成功',
								type: 'warning'
							});
							this.getPetList()
							//刷新房间笼子
							this.getPetsByShopList();
							//刷新table内所有宠物
							this.getTableData();
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			//获取门店名称
			getShopNameData(id) {
				let transferShopName = '';
				switch (id) {
					case '5e9412e0b2bfbc089daerr12':
						transferShopName = '花生宠物4S店(金水区店)'
						break
					case '5e9412e0b2bfbc089daerr14':
						transferShopName = '花生宠物(指挥中心店)'
						break
					case '5e9412e0b2bfbc089daerr16':
						transferShopName = '花生宠物4S店(万达店)'
						break
					case '5e9412e0b2bfbc089daerr17':
						transferShopName = '花生宠物(线上旗舰店)'
				}
				return transferShopName
			},
			//关闭添加宠物弹框
			handelRearchClick(val) {
				this.dialogAddPet_state = val;
				//待转移宠物列表
				this.getPetList();
				//初始化table内所有宠物
				this.getTableData();
			},
			//关闭添加宠物弹框
			handleAddPetClose(val) {
				this.dialogAddPet_state = val
			},
			//关闭接收弹框
			handleAddCageClose(val) {
				this.dialogAddCage_state = val
			},
			//关闭接收弹框刷新数据
			handleRearchClick(val) {
				this.dialogAddCage_state = val;
				this.getMemberReceiveList()
				this.getPetList()
				this.getTableData();
				this.getPetsByShopList();
			},
			//关闭操作日志弹框
			handleLogClose(val) {
				this.dialogLog_state = val
			},
			//点击接收
			handleAddCageClick(item) {
				this.dialogAddCage_state = true
				this.receiveId = item.transferId;
				this.eprom_no = item.eprom_no;
			},
			//获取接收宠物列表
			getMemberReceiveList() {
				let pamars = {
					shopId: this.shopValue
				}
				memberReceiveList(pamars).then((res) => {
					console.log('接收列表', res)
					if (res.code == 0) {
						this.receiveList = res.data;
						this.receiveCount = res.data.length;
					}
				})
			},
			//点击笼子
			handleCageClick(item) {
				console.log(item);
				this.cageId = item.cage_id;
				this.getTableData();
			},
			//选择房间
			handleRoomClick(item) {
				// console.log(item)
				this.roomId = item.room_id;
				this.cageId = '';
				if (item.room_id == '') {
					this.cageList = this.roomList
				} else {
					let arr = [];
					arr[0] = item
					this.cageList = arr;
				}
				this.getTableData()
			},
			// 获取门店下房间和笼子列表
			getPetsByShopList() {
				let pamars = {
					date: this.getStartEndData(this.calendarValue).startStr,
					shopId: this.shopValue
				}
				cage(pamars).then((res) => {
					console.log('门店', res)
					if (res.code == 0) {
						if (res.data.length == 0) {
							this.roomList = res.data;
							this.cageList = res.data;
							this.allDogNum = 0;
							this.allCatNum = 0;
							return
						}
						res.data.unshift({
							room_id: '',
							room_name: '全部',
							cage_info: res.data
						})
						this.roomList = res.data;
						this.cageList = res.data;
						let allDogNum = 0;
						let allCatNum = 0;
						for (let i = 0; i < res.data.length; i++) {
							if (res.data[i].room_id != '') {
								let catNum = 0;
								let dogNum = 0;
								for (let j = 0; j < res.data[i].cage_info.length; j++) {
									let catCount = 0;
									let dogCount = 0;
									
									for (let k = 0; k < res.data[i].cage_info[j].pet_list.length; k++) {
										//循环获取数量
										if (res.data[i].cage_info[j].pet_list[k].pet_type.value == '1') {
											catCount = (catCount + 1);
											// res.data[i].cat = catCount;
											console.log(res.data[i].cat)
											allCatNum = (allCatNum + 1);
											res.data[i].cage_info[j].catCount = catCount;
											
											catNum = catNum+res.data[i].cage_info[j].catCount;
										} else {
											dogCount = (dogCount + 1);
											// res.data[i].dog = dogCount;
											allDogNum = (allDogNum + 1);
											res.data[i].cage_info[j].dogCount = dogCount;
											dogNum = dogNum+res.data[i].cage_info[j].dogCount;
										}
										//判断是否异常和检查次数
										if (res.data[i].cage_info[j].pet_list[k].check_times < 3) {
											res.data[i].cage_info[j].check = true;
										} else {
											res.data[i].cage_info[j].check = false;
										}
										if (res.data[i].cage_info[j].pet_list[k].exception_times > 0) {
											res.data[i].cage_info[j].exception = true;
										} else {
											res.data[i].cage_info[j].exception = false;
										}
									}
									res.data[i].cat = catNum;
									res.data[i].dog = dogNum;
								}
							}
						}
						this.allDogNum = allDogNum;
						this.allCatNum = allCatNum;
					}
				})
			},
			//取消全选
			handleCancelAllPetClick() {
				for (let i = 0; i < this.petList.length; i++) {
					this.petList[i].isClick = false;
					this.allType = 0;
				}
				this.selectNum = 0;
			},
			//全选
			handleAllPetClick() {
				for (let i = 0; i < this.petList.length; i++) {
					this.petList[i].isClick = true;
					this.allType = 1;
				}
				this.selectNum = this.petList.length;
			},
			//选择宠物
			handlePetClick(index, item) {
				console.log(index, item)
				if (item.transferring == 1) {
					return
				}
				this.petList[index].isClick = !this.petList[index].isClick;
				let num = 0;
				for (let i = 0; i < this.petList.length; i++) {
					if (this.petList[i].isClick) {
						num++
					}
				}
				this.selectNum = num;
			},
			//tab切换
			handleTabClick(value) {
				this.tabs = value
			},
			//默认匹配手机号
			loadAll() {
				return [{
					value: '金水区店',
					phone: '19937868923'
				},]
			},
			//切换选择手机号
			handleSelect(item) {
				console.log(item);
				this.phoneValue = item.phone
			},
			//匹配建议
			querySearch(queryString, cb) {
				var restaurants = this.restaurants;
				var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
				// 调用 callback 返回建议列表的数据
				cb(results);
			},
			createFilter(queryString) {
				return (restaurant) => {
					return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
				};
			},
			//获取待转移宠物列表
			getPetList() {

				let pamars = {
					shopid: this.shopValue,
					petStatus: '1',
					breedid: this.breedid,
					applytype: this.transCate
				}
				getTransferList(pamars).then((res) => {
					console.log('待转移列表', res)
					if (res.code == 0) {
						if (res.data.data.length > 0) {
							for (let i = 0; i < res.data.data.length; i++) {
								res.data.data[i].isClick = false;
							}
							this.petList = res.data.data;
							this.petCount = res.data.count
						} else {
							this.petList = [];
							this.petCount = 0;
						}
					}
				})
			},
			//计算年龄
			getAge(birthday) {
				console.log(birthday)
				let birthdays = new Date(birthday.replace(/-/g, "/"));
				let d = new Date();
				let year = d.getFullYear() - birthdays.getFullYear() - (d.getMonth() < birthdays.getMonth() || (d
					.getMonth() ==
					birthdays.getMonth() && d.getDate() < birthdays.getDate()) ? 1 : 0);
				// console.log(birthdays.getMonth())
				return year;
			},
			//跳转详情
			handleNavClick(row) {
				console.log('时间', this.getStartEndData(this.calendarValue).formatDate)
				let query = {
					item: JSON.stringify(row),
					shopId: this.shopValue,
					calendarValue: this.getStartEndData(this.calendarValue).formatDate
				}
				this.$router.push({
					path: 'huotiDetail',
					query
				})
			},
			//切换数据
			handleChange() {
				for (let i = 0; i < this.petList.length; i++) {
					this.petList[i].isClick = false;
					this.allType = 0;
				}
				if (this.shopValue == '5e9412e0b2bfbc089daerr14') {
					this.page.pageSize = 15;
					this.calendarValue = new Date();
				} else {
					this.page.pageSize = 7;
				}
				this.page.page = 1;
				this.selectNum = 0;
				this.roomId = '';
				this.getPetsByShopList()
				this.getTableData();
				this.getPetList();
				this.getMemberReceiveList()
				this.getMonthData()
			},
			//获取笼子下宠物列表 
			getTableData() {
				let serchValue = this.serchValue;
				let shopId = this.shopValue;
				let className = this.className;
				let censor = this.censor;
				let deviant = this.deviant;
				let statu = this.statu;
				if (shopId == '5e9412e0b2bfbc089daerr14') {
					console.log('指挥中心')

				} else {
					console.log('其他门店', )
					let pamars = {
						shopId: shopId,
						roomId: this.roomId,
						cageId: this.cageId,
						applyType: className,
						checkStaus: censor,
						exceptionStatus: deviant,
						status: statu,
						date: this.getStartEndData(this.calendarValue).startStr + '',
						keyword: serchValue,
						pageIndex: this.page.page,
						pageSize: this.page.pageSize,
						minPrice: this.minPrice,
						maxPrice: this.maxPrice,
					}
					petList(pamars).then((res) => {
						console.log('所有宠物', res)
						if (res.code == 0) {
							this.tableData = res.data.data;
							this.page.total = res.data.count;
						}
					})
				}
			},
			//点击日期
			handelSecectClick(date) {
				// console.log(date, data)
				this.calendarValue = date;
				// console.log(this.calendarValue)
				this.getPetsByShopList()
				this.getTableData()

			},
			//获取开始时间和结束时间
			getStartEndData(nowDate) {
				// 获取时间
				let year = nowDate.getFullYear();
				let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1);
				let day = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate();
				let startTime = `${year}-${month}-${day} 00:00:00`;
				let endTime = `${year}-${month}-${day} 23:59:59`;
				let startStr = new Date(startTime) / 1000;
				let endStr = new Date(endTime) / 1000;
				let formatDate = `${year}-${month}-${day}`;
				return {
					startStr: startStr,
					endStr: endStr,
					formatDate: formatDate
				}
			},
			//分页方法
			changePage(num) {
				this.page.page = num;
				this.getTableData();
			},
			//重置
			handleResetClick() {
				this.serchValue = '';
				this.shopValue = this.$store.state.shopId;
				this.className = '0';
				this.censor = -1;
				this.deviant = -1;
				this.statu = -99;
				this.minPrice = null;
				this.maxPrice = null;
				this.getTableData()
			},
			exportpetall() {
				// axios.post('', {
				// 	responseType: 'blob'
				// })
				axios({
						method: 'post',
						url: 'http://test.huashengchongwu.com:8000/api/product/pet/category/stock/export',
						responseType: 'blob'
					})
					.then(response => {
						const url = window.URL.createObjectURL(new Blob([response.data], {
							type: "application/ms-excel"
						}));
						const link = document.createElement('a');
						link.style.display = 'none';
						link.href = url;
						link.setAttribute('download', `宠物汇总.xls`);
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						window.URL.revokeObjectURL(url);
					})
				
			}

		},
	}
</script>

<style lang="scss" scoped>
	.page {
		display: flex;
		width: 100%;

		.pageLeft {
			margin-right: 14px;
			display: flex;
			flex-direction: column;

			.petView {
				color: #2A2A2A;
				flex: 1;
				background: #fff;
				display: flex;
				flex-direction: column;
				overflow-x: hidden;
				overflow-y: scroll;
				padding: 10px;

				.tabView {
					display: flex;
					justify-content: space-around;
					margin-bottom: 10px;
					padding-bottom: 2px;
					border-bottom: 1px solid rgba(0, 0, 0, 0.15);

					.tabItem {
						// width: 88px;
						line-height: 32px;
						font-size: 14px;
						box-sizing: border-box;
						text-align: center;
						position: relative;

						span {
							position: absolute;
							right: 0;
							top: 0;
							font-size: 8px;
							background: red;
							display: block;
							padding: 0 2px;
							border-radius: 50%;
							color: #fff;
							line-height: 16px;
						}
					}

					.active {
						border-bottom: solid 1px #1890FF;
					}
				}

				.screenView {
					display: flex;
					margin-bottom: 4px;
					justify-content: space-between;
				}

				.numView {
					display: flex;
					justify-content: space-between;
					line-height: 34px;
					font-size: 14px;
					border-bottom: solid 1px #DEDEDE;
				}

				.pets {
					flex: 1;
					overflow-x: hidden;
					overflow-y: scroll;

					.petItem {
						display: flex;
						align-items: center;
						height: 60px;
						font-size: 12px;
						border-bottom: solid 1px #DEDEDE;

						.petItemL {
							flex: 1;
							display: flex;
							align-items: center;

							.petName {
								margin: 0 10px;
							}

							img {
								width: 36px;
								height: 36px;
								border-radius: 100%;
							}
						}

						.petItemR {
							width: 16px;
							height: 16px;
							border-radius: 100%;
							box-sizing: border-box;
							background: rgba(0, 0, 0, 0.04);
							border: 1px solid rgba(0, 0, 0, 0.15);
						}

						.isClick {
							width: 16px;
							height: 16px;
							border-radius: 100%;
							background: #1890FF;
						}

						.receiveBtn {
							padding: 4px 8px;
							border-radius: 4px;
							box-sizing: border-box;
							border: solid 1px #cecece;
						}
					}
				}

				.pets::-webkit-scrollbar {
					display: none;
				}

				.petBtn {
					padding-top: 10px;
					display: flex;
					justify-content: space-between;
				}
			}

			.petView::-webkit-scrollbar {
				display: none;
			}


		}

		.titleView {
			height: 62px;
			line-height: 62px;
			display: flex;
			background: #fff;
			justify-content: space-around;
			align-items: center;
			border-radius: 6px;
			margin: 10px 0;

			.titleInput {
				width: 192px;
			}

			.titleDate {
				width: 224px;
			}

			.titleSelect {
				width: 126px;
			}
		}

		.flex {
			display: flex;
			align-items: center;
		}

		.m-r-10 {
			margin-right: 10px;
		}

		.lists {
			flex: 1;
			display: flex;
			flex-direction: column;

			.headView {
				display: flex;
				background: #fff;
				padding-left: 20px;
				line-height: 40px;
				border-bottom: solid 1px rgba(0, 0, 0, .08);

				div:nth-of-type(1) {
					color: #2A2A2A;
					font-size: 16px;
					margin-right: 10px;
					font-weight: bold;
				}

				div:nth-of-type(2) {
					color: #666666;
					font-size: 14px;
					margin-right: 20px;
				}

				div:nth-of-type(3) {
					color: red;
					font-size: 14px;
					font-weight: bold;
				}
			}

			.storeView {
				// flex: 1;
				height: 280px;
				background: #fff;
				display: flex;
				padding-top: 10px;
				overflow-x: hidden;
				overflow-y: scroll;

				.roomView {
					width: 484px;
					height: 100%;
					border-right: solid 1px rgba(0, 0, 0, .08);
					overflow-x: hidden;
					overflow-y: scroll;

					.room {
						width: 96px;
						line-height: 34px;
						box-sizing: border-box;
						border: 1px solid #979797;
						border-radius: 2px;
						text-align: center;
						font-size: 14px;
						color: #3A3A3A;
						float: left;
						margin-left: 20px;
						margin-bottom: 20px;
					}

					.roomActive {
						width: 96px;
						line-height: 34px;
						box-sizing: border-box;
						border: 1px solid #979797;
						border-radius: 2px;
						text-align: center;
						font-size: 14px;
						color: #fff;
						float: left;
						margin-left: 20px;
						margin-bottom: 20px;
						background: #1890FF;
					}
				}

				.roomView::-webkit-scrollbar {
					display: none;
				}

				.cageView {
					flex: 1;
					overflow-x: hidden;
					overflow-y: scroll;

					.cage {
						overflow: hidden;

						.cageTitle {
							font-size: 14px;
							font-weight: bold;
							// margin-bottom: 10px;
							padding-left: 14px;
							line-height: 30px;
						}

						.cageItem {
							display: flex;
							flex-direction: column;
							justify-content: center;
							align-items: center;
							width: 80px;
							height: 40px;
							box-sizing: border-box;
							position: relative;
							border: solid 1px #979797;
							border-radius: 4px;
							margin-left: 14px;
							margin-bottom: 14px;
							float: left;
							font-size: 14px;
							box-sizing: border-box;

							.petNum {
								font-size: 12px;
								margin-top: 4px;
							}
						}

						.cageItemActive {
							display: flex;
							flex-direction: column;
							justify-content: center;
							align-items: center;
							width: 80px;
							height: 40px;
							box-sizing: border-box;
							position: relative;
							border: solid 1px #979797;
							border-radius: 4px;
							margin-left: 14px;
							margin-bottom: 14px;
							color: #fff;
							float: left;
							font-size: 14px;
							background: #1890FF;
							box-sizing: border-box;

							.petNum {
								font-size: 12px;
								margin-top: 4px;
							}
						}

						.iconYi {
							width: 17px;
							height: 16px;
							position: absolute;
							left: 0;
							top: 0;
						}

						.iconQue {
							width: 17px;
							height: 16px;
							position: absolute;
							right: 0;
							top: 0;
						}
					}
				}

				.cageView::-webkit-scrollbar {
					display: none;
				}
			}

			.storeView::-webkit-scrollbar {
				display: none;
			}

			.listFlex {
				// flex: 1;
				display: flex;
			}


			.petTable {
				flex: 1;
				padding: 0 20px;
				// padding-bottom: 20px;
				background: #fff;
			}
		}

		.acticeYellow {
			color: #FFAE11;
		}

		.activeRed {
			color: #FF182A;
		}

		.dateSpan {
			display: block;
			width: 100%;
			line-height: 30px;
			text-align: center;
		}

		.dateView {
			width: 100%;
			height: 100%;
			position: relative;

			.circle1 {
				width: 4px;
				height: 4px;
				position: absolute;
				left: 0;
				right: 0;
				bottom: 4px;
				background: #FCB300;
				border-radius: 50%;
				margin: 0 auto;
			}

			.circle2 {
				width: 4px;
				height: 4px;
				position: absolute;
				left: 0;
				right: 0;
				bottom: 4px;
				background: #03BF23;
				border-radius: 50%;
				margin: 0 auto;
			}

		}

		.paging {
			background: #fff;
			margin-top: 0;
			padding: 10px 0;
		}
	}
</style>
